import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'

import PageWrapper from '@/components/PageWrapper'
import Iconify from '@/components/Iconify'

import Logo from '../components/shared/logo'
import SubmitButton from '../components/shared/submit-button'
import { AuthTextField } from '../components/shared'
import { useAuth } from '../hooks/use-auth'
import { authApi } from '../services/auth-api'
import { resetPasswordSchema } from '../validations/auth-schemas'
import {
  Actions,
  ErrorText,
  Form,
  PageContainer,
  Panel,
  SuccessText,
  Text,
  Title,
} from './reset-password-page.styled'

export function ResetPasswordPage (props) {
  const { isAuthenticated, logout, loginStatus } = useAuth()
  const token = props.match.params.token

  const [submitState, setSubmitState] = useState({
    changeSuccess: null,
    submitting: false,
    apiError: false,
  })

  const {
    control,
    handleSubmit,
  } = useForm({
    resolver: zodResolver(resetPasswordSchema),
    defaultValues: {
      password: '',
      cpassword: '',
    },
  })

  useEffect(() => {
    if (isAuthenticated && logout && !loginStatus) {
      logout(false)
    }
  }, [isAuthenticated, loginStatus, logout])

  const onSubmit = (values) => {
    setSubmitState({ changeSuccess: null, submitting: true, apiError: false })

    authApi
      .resetPassword(token, { password: values.password, cpassword: values.cpassword })
      .then((response) => {
        if (response.data?.success) {
          setSubmitState({ changeSuccess: true, submitting: false, apiError: false })
          setTimeout(() => {
            window.location = '/ingresar'
          }, 2000)
        } else {
          setSubmitState({ changeSuccess: false, submitting: false, apiError: true })
        }
      })
      .catch(() => {
        setSubmitState({ changeSuccess: false, submitting: false, apiError: true })
      })
  }

  const { changeSuccess, submitting, apiError } = submitState

  return (
    <PageWrapper>
      <PageContainer>
        <Panel>
          <Logo src='/images/Pickwin.png' alt='Pickwin logo' />

          <Title>Cambiar contraseña</Title>

          {changeSuccess !== true && (
            <Text>Ingresa tu nueva contraseña para recuperar el acceso a tu cuenta.</Text>
          )}

          {apiError && (
            <ErrorText>Lo sentimos, no podemos cambiar tu contraseña.</ErrorText>
          )}

          {changeSuccess === true && (
            <SuccessText>
              <Iconify
                icon='ion:checkmark-circle'
                style={{
                  fontSize: '1.4em',
                  verticalAlign: 'bottom',
                  marginRight: '0.25em',
                }}
              />
              Tu contraseña se cambió con éxito.
              <br />
              En un momento te redireccionaremos a la pantalla de login.
            </SuccessText>
          )}

          {changeSuccess !== true && (
            <Form onSubmit={handleSubmit(onSubmit)} noValidate>
              <AuthTextField
                control={control}
                name='password'
                type='password'
                placeholder='Nueva contraseña'
                iconSrc='/images/Icono candado.png'
                autoComplete='new-password'
              />

              <AuthTextField
                control={control}
                name='cpassword'
                type='password'
                placeholder='Repetir contraseña'
                iconSrc='/images/Icono candado.png'
                autoComplete='new-password'
              />

              <Actions>
                <SubmitButton
                  type='submit'
                  loading={submitting}
                  disabled={submitting}
                  style={{ maxWidth: 400 }}
                >
                  Cambiar contraseña
                </SubmitButton>
              </Actions>
            </Form>
          )}
        </Panel>
      </PageContainer>
    </PageWrapper>
  )
}

export default ResetPasswordPage
